import { Injectable } from '@angular/core';
import { AdvancedFormButton } from "@magieno/angular-advanced-forms";
import { ButtonStyleEnum } from '@magieno/angular-advanced-forms';
import { ButtonTypeEnum } from '@magieno/angular-advanced-forms';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import { FormFactory } from "@magieno/angular-advanced-forms";
import {
  CreateCorporateClientOptions,
} from '../../../../../../../../common/src/options/create-corporate-client.options';

@Injectable()
export class CreateCorporateClientFormFactory {
  constructor(protected readonly formFactory: FormFactory) {
  }

  create(): AdvancedForm<CreateCorporateClientOptions> {
    return this.formFactory.create(new CreateCorporateClientOptions(), [
      new AdvancedFormButton('SAVE', ButtonStyleEnum.Primary, 'Sauvegarder', ButtonTypeEnum.Submit),
    ]);
  }
}
